import React from "react";
import "swiper/css";
import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/scrollbar";
const useSwiperCss = () => {
  return;
};

export default useSwiperCss;
